import { render } from "./AiMonitoringRegionModal.vue?vue&type=template&id=9e89f152&scoped=true&ts=true"
import script from "./AiMonitoringRegionModal.vue?vue&type=script&lang=ts"
export * from "./AiMonitoringRegionModal.vue?vue&type=script&lang=ts"

import "./AiMonitoringRegionModal.vue?vue&type=style&index=0&id=9e89f152&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e89f152"]])

export default __exports__